import { SearchDocumentType, TargetType } from '@lumapps/analytics-tracking/types';

import { SEARCH_RESULT_TYPES } from '../constants';

export const searchDocumentTypeAnalytics = {
    [SearchDocumentType.PLAY_VIDEO]: TargetType.PLAY_VIDEO,
    [SearchDocumentType.PLAY_PLAYLIST]: TargetType.PLAYLIST,
    [SearchDocumentType.ARTICLE]: TargetType.ARTICLE,
    [SearchDocumentType.COMMUNITY]: TargetType.COMMUNITY,
    [SearchDocumentType.CONTENT]: TargetType.CONTENT,
    [SearchDocumentType.DIRECTORY_ENTRY]: TargetType.DIRECTORY_ENTRY,
    [SearchDocumentType.EVENT]: TargetType.EVENT,
    [SearchDocumentType.MEDIA]: TargetType.MEDIA,
    [SearchDocumentType.POST]: TargetType.POST,
    [SearchDocumentType.USER]: TargetType.USER,
    [SearchDocumentType.EXTENSION]: TargetType.SEARCH_EXTENSION,
    [SearchDocumentType.GCS_ARTICLE]: TargetType.ARTICLE,
    [SearchDocumentType.GCS_COMMUNITY]: TargetType.COMMUNITY,
    [SearchDocumentType.GCS_DIRECTORY_ENTRY]: TargetType.DIRECTORY_ENTRY,
    [SearchDocumentType.GCS_POST]: TargetType.POST,
    [SearchDocumentType.GCS_USER]: TargetType.USER,
};

/** Converts search docutment types to analytics document type. As this field is mandatory for analytics,
 * we consider that result type not matching a lumapps result type to be a search exetension type
 */
export const convertDocumentTypeForAnalytics = (documentType?: SearchDocumentType) => {
    if (documentType && documentType in searchDocumentTypeAnalytics) {
        return searchDocumentTypeAnalytics[documentType];
    }
    return TargetType.SEARCH_EXTENSION;
};

/**
 * Search result types (used by the search box suggestions) that have a dedicated analytics target type
 */
const searchResultTypeAnalytics: Partial<Record<SEARCH_RESULT_TYPES, TargetType>> = {
    [SEARCH_RESULT_TYPES.ARTICLE]: TargetType.ARTICLE,
    [SEARCH_RESULT_TYPES.COMMUNITY]: TargetType.COMMUNITY,
    [SEARCH_RESULT_TYPES.DIRECTORY_ENTRY]: TargetType.DIRECTORY_ENTRY,
    [SEARCH_RESULT_TYPES.MEDIA]: TargetType.MEDIA,
    [SEARCH_RESULT_TYPES.POST]: TargetType.POST,
    [SEARCH_RESULT_TYPES.USER]: TargetType.USER,
};

/**
 * Converts a search result type (used by search box suggestions) to an analytics target type.
 * As this field is mandatory for analytics, a result type not matching a lumapps result type
 * falls back to `TargetType.SEARCH`.
 */
export const convertSearchResultTypeForAnalytics = (resultType?: SEARCH_RESULT_TYPES): TargetType => {
    if (resultType && resultType in searchResultTypeAnalytics) {
        return searchResultTypeAnalytics[resultType] as TargetType;
    }
    return TargetType.SEARCH;
};
